// extracted by mini-css-extract-plugin
export default {"button":"Sr-z","reviewSort":"Tr-z"};